import { useContext, useEffect } from 'react'
import { AuthContext } from '~/utils/context/auth.context'
import { getSocket } from './socketManager'

interface DoorNotificationData {
  storeId?: string | number
  kioskId?: string | number
  storeLabel?: string
  timestamp?: string
  [key: string]: unknown
}

export const useOpenDoorNotifications = (onDoorOpen?: (data: DoorNotificationData) => void) => {
  const { authenticated } = useContext(AuthContext)

  useEffect(() => {
    if (!authenticated) return

    const socket = getSocket()

    const handler = (data: DoorNotificationData) => {
      if (onDoorOpen) onDoorOpen(data)
    }

    socket.on('door-open', handler)

    return () => {
      socket.off('door-open', handler)
    }
  }, [authenticated, onDoorOpen])
}
